import React from "react";
import MoreOptions from "../../../shared-ui/more-options";
import { IPopupMenuOption } from "../../../shared-ui/popup-menu";
import { IShardClusterRepository } from "./shard-repositories-section";


export interface IMoreOptionProps {
  storagePoolNode: IShardClusterRepository;
  onEditStorageNode: (node: IShardClusterRepository) => void;
}

export function MoreOption(props: IMoreOptionProps) {
  function getOptions() {
    const options: IPopupMenuOption[] = [
      {
        label: "Manage",
        onClick: () => props.onEditStorageNode(props.storagePoolNode)
      }
    ];

    return options;
  }

  return (
    <MoreOptions
      testId="more-options"
      options={getOptions()}
    />
  );
}
